export default "__VITE_ASSET__Cnvm6R6V__"